module.exports = __webpack_public_path__ + "static/media/bus.70b8a605.png";